import AcrylicPlatesDetailComponent from "src/components/features/superAdmin/acrylicPlatesDetailComponent";

const DetailAcrylicPage = () => <AcrylicPlatesDetailComponent />;

export default DetailAcrylicPage;
